import { TrendingUp } from 'lucide-react';

const GrowthBadge = ({ badge }) => {
  if (!badge) return null;

  const variants = {
    11: 'bg-orange-100 text-orange-700 border-orange-200',
    20: 'bg-slate-100 text-slate-700 border-slate-200',
    50: 'bg-yellow-100 text-yellow-700 border-yellow-200',
    250: 'bg-blue-100 text-blue-700 border-blue-200',
  };

  const threshold = badge.threshold;
  const variant = variants[threshold] || variants[20];

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide shadow-sm border ${variant}`}
      data-testid="growth-badge"
    >
      <TrendingUp className="h-3.5 w-3.5" />
      Seuil {threshold} - {badge.year}
    </span>
  );
};

export default GrowthBadge;